//#region configs
export const SET_LOADING = "SET_LOADING";
export const SET_SIDEBAR = "SET_SIDEBAR";
export const SET_TABS = "SET_TABS";
export const CLEAR_TABS = "CLEAR_TABS";
//#endregion

//#region Authenticate
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_AUTHENTICATE = "SET_AUTHENTICATE";
export const SET_PERMISSION = "SET_PERMISSION";
//#endregion

export const SET_FILTER = "SET_FILTER";
